export interface StoredRecord {
	attrs: any;
	originalAttrs: any;
	isIdOnly?: boolean;
}
export interface StoredDataById {
    [id: string]: StoredRecord
}
export class DataIndex {
    private dataById: StoredDataById;
    getDataAttrs(id) {
		return this.dataById[id] ? Object.assign({}, this.dataById[id].attrs) : null;
	}
    getDataOriginAttrs(id) {
		return this.dataById[id] ? Object.assign({}, this.dataById[id].originalAttrs) : null;
	}
    setDataAttrs(id, prop, val) {
		if (!this.dataById[id]) {
			return;
		}
		this.dataById[id].attrs[prop] = val;
	}
    setDataOriginAttrs(id, prop, val) {
		if (!this.dataById[id]) {
			return;
		}
		this.dataById[id].originalAttrs[prop] = val;
	}

    addDataToStoredRecords(data: any[], idCol: string, handlePrev?: 'replace' | 'mergeToPrev' | 'prev') {
		if (!data) {
			return;
		}
		handlePrev = handlePrev || 'mergeToPrev';
		data.forEach(i => {
			switch (handlePrev) {
				case 'replace':
					this.dataById[i[idCol]] = {
						attrs: i,
						originalAttrs: JSON.parse(JSON.stringify(i))
					};
					break;
				case 'mergeToPrev':
					if (this.dataById[i[idCol]]) {
						this.dataById[i[idCol]].originalAttrs = JSON.parse(JSON.stringify(i));
						this.dataById[i[idCol]].attrs = Object.assign(i, this.dataById[i[idCol]].attrs);
					} else {
						this.dataById[i[idCol]] = {
							attrs: i,
							originalAttrs: JSON.parse(JSON.stringify(i))
						};	
					}
					break;
				case 'prev':
					if (this.dataById[i[idCol]]) {
						return;
					}
					this.dataById[i[idCol]] = {
						attrs: i,
						originalAttrs: JSON.parse(JSON.stringify(i))
					};
					break;
			}
		})
	}
    removeDataFromStoredRecords(id) {
		delete this.dataById[id];
	}
    setDataById(data: StoredDataById) {
        this.dataById = data;
    }
}
